import { analyticsEvent } from "@util/analytics";

interface WithMessage {
  message: string;
}

export function emitDuplicatePaymentProfileErrorIfNeeded(
  err: WithMessage,
): boolean {
  if (
    err.message.includes("This card is on file for a different Alchemy account")
  ) {
    analyticsEvent("Duplicate Credit Card Entered");
    return true;
  }

  return false;
}
